import {  Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import { AppState } from '../../../store/rootReducer';

const Investments = (props: any) => {
    const { investmentSummary } = useSelector(
        (state: AppState) => state.dashboard
    );
    const [currInvestment, setCurrInvestment] = useState<any>(null);
    const [pastInvestment, setPastInvestment] = useState<any>(null);
    const [type, setType] = useState<any>('');
    useEffect(() => {
        console.log(window.location.pathname.split("/").pop());
        const pathName = window.location.pathname.split("/").pop()
        setType(pathName);
    },[]);

    useEffect(() => {
        if (investmentSummary?.data?.current_investments?.length > 0) {
            const currInvestments = investmentSummary?.data?.current_investments;
            setCurrInvestment(currInvestments);
        }
        if (investmentSummary?.data?.past_investments?.length > 0) {
            const past_investment = investmentSummary?.data?.past_investments;
            setPastInvestment(past_investment);
        }
    }, [investmentSummary])
    return (
        <BackgroundTheme>
            <Box sx={{ mb: '16px' }}>
                <Typography variant='h3' className='recentTransactions'>
                    {type === 'current' ? 'Current Investments' : type === 'past' ?'Past Investments' : ''}
                </Typography>
            </Box>
            {type === 'current' &&
                <Box className=' portfolioSummary'>
                    {currInvestment.length > 0 ?
                        currInvestment.map((ele: any) => {
                            return (
                                <div className='investment-row'>
                                    <div className='invested_amount fs-16 fw-400'>
                                        <div >Invested Amount</div>
                                        <div >₹{ele.invested_amount}</div>
                                    </div>
                                    <div className="roi fs-16 fw-400">
                                        <div> ROI</div>
                                        <div>{ele.investment_roi}%</div>
                                    </div>
                                    <div className='lockin_tenure fs-16 fw-400'>
                                        <div>Lockin Tenure</div>
                                        <div>{ele.lockin_tenure}M</div>
                                    </div>
                                    <div className='transaction_id fs-16 fw-400'>
                                        <div> transaction ID</div>
                                        <div>{ele.transaction_id}</div>
                                    </div>
                                    <div className='transaction_date fs-16 fw-400'>
                                        <div >Transaction Date</div>
                                        <div >{ele.transaction_date}</div>
                                    </div>
                                    <hr />
                                </div>
                            )
                        }) : 'No current investments found'}

                </Box>
            }
            {type === 'past' &&
                <Box className='portfolioSummary'>
                    {pastInvestment?.length > 0 ?
                        pastInvestment.map((ele: any) => {
                            return (
                                <div className='investment-row'>
                                    <div className='invested_amount fs-16 fw-400'>
                                        <div >Invested Amount</div>
                                        <div >₹{ele.invested_amount}</div>
                                    </div>
                                    <div className="roi fs-16 fw-400">
                                        <div> ROI</div>
                                        <div>{ele.investment_roi}%</div>
                                    </div>
                                    <div className='lockin_tenure fs-16 fw-400'>
                                        <div>Lockin Tenure</div>
                                        <div>{ele.lockin_tenure}M</div>
                                    </div>
                                    <div className='transaction_id fs-16 fw-400'>
                                        <div> transaction ID</div>
                                        <div>{ele.transaction_id}</div>
                                    </div>
                                    <div className='transaction_date fs-16 fw-400'>
                                        <div >Transaction Date</div>
                                        <div >{ele.transaction_date}</div>
                                    </div>
                                    <hr />
                                </div>
                            )
                        })
                        : 'No past investments found'
                    }

                </Box>

            }
        </BackgroundTheme>
    )
}

export default Investments;